import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { BsSearch } from "react-icons/bs";
import { HiInformationCircle } from "react-icons/hi";
import { useTheme } from '../../../contexts/ThemeContext'
import { AboutUsModal } from '../AboutUsModal'

import {
  RightTopContainer,
  RightTopActions,
  AboutUsButton,
  SearchIconWrapper
} from './styles'

export const RightTop = (props) => {

  const [theme, { update }] = useTheme()
  const { i18n, t } = useTranslation();

  const currentLng = localStorage.getItem('i18nextLng');
  const { search, searchIconShowed } = props
  const [isAboutOpen, setIsAboutOpen] = useState(false)

  // useEffect(() => {

  //   if (currentLng === 'ar') {
  //     document.body.dir = 'rtl';
  //   } else {
  //     document.body.dir = 'ltr';
  //   }
  // }, [currentLng]);

  const changeLanguage = () => {
    if (currentLng === 'ar') {
      i18n.changeLanguage("en")
      localStorage.setItem('i18nextLng', 'en')
      update({ ...theme, rtl: false });
    } else {
      i18n.changeLanguage("ar")
      localStorage.setItem('i18nextLng', 'ar')
      update({ ...theme, rtl: true });
    }
    
  }

  const searchOpen = () => {
    //debugger
    search(true);
    if(searchIconShowed)
    document.getElementById('rightContainer').classList.add("remove-image");
    else
    document.getElementById('rightContainer').classList.remove("remove-image");

  }

  return (
    <RightTopContainer>
      <AboutUsButton type="button" onClick={() => setIsAboutOpen(true)} aria-label={t('About Us')} title={t('About Us')}>
        <HiInformationCircle size={24} />
      </AboutUsButton>

      <RightTopActions>
        {searchIconShowed && (
          <SearchIconWrapper onClick={() => searchOpen()}>
            <BsSearch size={20} />
          </SearchIconWrapper>
        )}

        {currentLng === 'en'
          ? <SearchIconWrapper onClick={changeLanguage}><span>ع</span></SearchIconWrapper>
          : <SearchIconWrapper onClick={changeLanguage}><span>EN</span></SearchIconWrapper>
        }
      </RightTopActions>

      <AboutUsModal open={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
    </RightTopContainer>
  )
}
